<template>
  <Teleport to="body">
    <div
      v-if="show"
      class="tw-fixed tw-inset-0 tw-z-50 tw-overflow-y-auto"
    >
      <div class="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-p-4">
        <div
          class="tw-fixed tw-inset-0 tw-bg-slate-900 tw-bg-opacity-60 tw-transition-opacity"
          @click="$emit('close')"
        />
        <div class="tw-relative tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-max-w-md tw-w-full tw-p-8">
          <div class="tw-text-center">
            <div class="tw-mx-auto tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-full tw-bg-emerald-50">
              <svg
                class="tw-h-7 tw-w-7 tw-text-emerald-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h3 class="tw-mt-4 tw-text-xl tw-font-semibold tw-text-slate-900">
              Payment complete
            </h3>
            <p class="tw-mt-2 tw-text-sm tw-text-slate-500">
              Thank you. Your payment has been processed successfully and a confirmation email is on its way.
            </p>
            <p class="tw-mt-4 tw-text-sm tw-font-medium tw-text-slate-800">
              Order reference: <span class="tw-font-semibold">{{ reference }}</span>
            </p>
            <button
              class="tw-mt-6 tw-w-full tw-inline-flex tw-justify-center tw-rounded-md tw-border tw-border-transparent tw-bg-blue-600 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2"
              @click="$emit('close')"
            >
              Close window
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    reference: {
      type: String,
      default: ''
    }
  },
  emits: ['close']
}
</script>
